export class HelpDesk {
   helpdeskid: number;
    menuid: number;
    pagename: string;
    helpcontent: string;
    createdby: number;
    createdon: string;
    modifiedby: number;
    modifiedon: string;
    active: number;
}
